/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');

import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'

import Vue from 'vue'
import 'livewire-vue'
import {ApolloClient, ApolloLink, createHttpLink} from "@apollo/client/core";
import {InMemoryCache} from "@apollo/client/cache";
import VueApollo from 'vue-apollo'
import {createLighthouseSubscriptionLink} from "@thekonz/apollo-lighthouse-subscription-link";

window.Vue = Vue;

Vue.use(VueApollo);
// Install BootstrapVue
Vue.use(BootstrapVue);
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin);

// HTTP connection to the API
const httpLink = createHttpLink({
    // You should use an absolute URL here
    uri: '/graphql',
    credentials: 'same-origin',
    headers: {
        "X-CSRF-TOKEN": document.querySelector('meta[name="csrf-token"]').content,
    }
})

// Cache implementation
const cache = new InMemoryCache()

// Create the apollo client
const apolloClient = new ApolloClient({
    link: ApolloLink.from([
        createLighthouseSubscriptionLink(window.Echo),
        httpLink,
    ]),
    credentials: 'same-origin',
    cache: cache,
})

const apolloProvider = new VueApollo({
    defaultClient: apolloClient,
})

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */
/*
const files = require.context('./', true, /\.vue$/i)
files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))
*/
/*
Vue.component('example-component', require('./components/ExampleComponent.vue').default);
*/
Vue.component('chat', require('./components/Chat').default);
Vue.component('edit-event', require('./components/EditEvent').default);
Vue.component('player', require('./components/Player').default);
/*
Vue.component('send-message-box', require('./components/SendMessageBox').default);
Vue.component('register-form-fields', require('./components/RegisterFormFields.vue').default);
*/

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

const app = new Vue({
    el: '#app',
    // inject apolloProvider here like vue-router or vuex
    apolloProvider,
});

import EventPing from "./event-ping";

window.EventPing = new EventPing();

window.ClassicEditor = require('@ckeditor/ckeditor5-build-classic');
window.tail = require('tail.select/js/tail.select-es6');
window.flatpickr = require('flatpickr/dist/flatpickr');
const Italian = require('flatpickr/dist/l10n/it').default.it;
flatpickr.localize(Italian);

import 'emoji-picker-element';
import {Picker} from 'emoji-picker-element';

window.Picker = Picker;
